export default "/images/c143b152b80b68d810a2ef2f4a2dbab3.avif";